import {
    Box,
    Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Center,
    Button,
    Text
} from '@chakra-ui/react'
import scrollBarCssConfig from '../style/scrollBarCssConfig'
import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios'
import { urls } from '../config'
import { ArrowLeftIcon } from "@chakra-ui/icons"


export default function Result() {

    const [searchParams] = useSearchParams();
    const OrderNO = searchParams.get('OrderNO');
    const [result, setResult] = useState()

    const getOrderResult = useCallback(async () => {
        if (OrderNO) {
            const data = await axios.post(urls.authlogUrl, { OrderNO })
            if (data.status === 200 && data.data.status) {
                setResult(data.data.data)
            }
        }
    }, [OrderNO])

    useEffect(() => {
        getOrderResult()
    }, [getOrderResult])

    let alertCom = null

    if (result) {
        if (result.Success) {
            alertCom = <Alert status='success'>
                <AlertIcon />
                刷卡結果：成功
            </Alert>
        } else {
            alertCom = <Alert status='error'>
                <AlertIcon />
                刷卡結果：失敗（{result.ShowResultContent}）
            </Alert>
        }
    } else {
        return <></>
    }

    return <Box
        p={10}
        overflow="auto"
        h="100%"
        w="100%"
        css={scrollBarCssConfig}
    >
        <Heading
            as='h1'
            size={{ base: 'lg', md: 'xl' }}
            lineHeight={2}
        >
            和信醫院<br />健康檢查網路繳費結果
        </Heading>
        <Box py={5}>
            {alertCom}
        </Box>
        <RText
        >
            繳款人姓名：{result.PayName}
        </RText>
        <RText
        >
            身份證字號：{result.PayIdentify}
        </RText>
        <RText
        >
            繳款人手機：{result.PayCell}
        </RText>
        <RText
        >
            室內電話：{result.PayPhone}
        </RText>
        <RText
        >
            繳款人數：{result.PayNumber}
        </RText>
        <RText
        >
            繳款金額：{result.PayAmount}
        </RText>
        <RText
        >
            備註：{result.Memo}
        </RText>
        <Center py={5}>
            <Button                
                borderRadius={5}
                type="submit"
                variant="solid"
                colorScheme='purple'
                size={{ base: 'md', md: 'lg' }}
                leftIcon={<ArrowLeftIcon />}
                onClick={()=>{window.location.href="https://www.kfsyscc.org/"}}
            >
                回醫院首頁
            </Button>
        </Center>
    </Box>
}

const RText = (props) => {

    return <Text
        fontSize={{ base: "md", md: "lg" }}
        p={2}
    >
        {props.children}
    </Text>
}